import { useEffect, useState } from "react";

const useApplePay = () => {
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    
    try {
      setIsApplePayAvailable(window.ApplePaySession && window.ApplePaySession.canMakePayments());
    } catch (error) {
      console.log("Apple Pay SDK Error: ", error);
      setIsApplePayAvailable(false)
    }
  }, []);

  return isApplePayAvailable;
}

export default useApplePay;